import React, { useEffect, useState } from 'react';
import "./Order.css";
import { FaEye, FaTrash, FaFileExport, FaStar, FaFilter } from "react-icons/fa";
import axios from 'axios';
import VisibilityIcon from '@mui/icons-material/Visibility';

const Order = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({ name: "", orderType: "", payment: "" });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState("");
  const [selectedYear, setSelectedYear] = useState("2024");
  const [selectedMonth, setSelectedMonth] = useState("06");
  const [selectedWeek, setSelectedWeek] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [image, setImage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [ticketType, setTicketType] = useState("");
  const [message, setMessage] = useState("");
  const [imageBase64, setImageBase64] = useState("");

  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = orders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(orders.length / itemsPerPage);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('authToken'); // ✅ get auth token

    if (!userId) {
      console.error('User ID not found in localStorage.');
      return;
    }

    axios.get(
      `https://backend.maamaas.com/food/api/orders/user/${userId}`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    )
      .then(response => {
        const sortedOrders = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setOrders(sortedOrders);
      })
      .catch(error => {
        console.error('Error fetching orders:', error);
      });
  }, []);

  const getFilteredOrders = (filterType, selectedValue) => {
    if (!selectedValue) return orders;
    return orders.filter((order) => {
      const orderDate = new Date(order.date);
      if (filterType === "Yearly") {
        return orderDate.getFullYear().toString() === selectedValue;
      } else if (filterType === "Monthly") {
        return `${orderDate.getFullYear()}-${(orderDate.getMonth() + 1).toString().padStart(2, "0")}` === selectedValue;
      } else if (filterType === "Weekly") {
        const startOfWeek = new Date(orderDate);
        startOfWeek.setDate(orderDate.getDate() - orderDate.getDay());
        return startOfWeek.toISOString().slice(0, 10) === selectedValue;
      }
      return true;
    });
  };

  const filteredOrders = getFilteredOrders();
  const getWeekOfMonth = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    return Math.ceil(day / 7);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr.split('-').reverse().join('-'));
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const openPopup = (filterType) => {
    setCurrentFilter(filterType);
    setIsPopupOpen(true);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [currentFilter]: e.target.value });
  };

  const handleToggle = () => {
    setShowDetails((prev) => !prev);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageBase64(reader.result.split(",")[1]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSend = async () => {
    if (!ticketType || !message) {
      alert("Please fill in all fields");
      return;
    }

    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken"); // ✅ get auth token

    const payload = {
      ticketType,
      message,
      attachmentUrl: imageBase64 || null,
      userId,
    };

    try {
      const res = await fetch(
        `https://backend.maamaas.com/food/tickets/create/${selectedOrderId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }), // ✅ include token if exists
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Failed to raise ticket");
      alert("Ticket raised successfully!");
      setShowPopup(false);
      setSelectedOrderId(null);
      setTicketType("");
      setMessage("");
      setImageBase64("");
    } catch (err) {
      alert("Error: " + err.message);
    }
  };


  // Responsive styles
  const containerStyle = {
    marginTop: '38px',
    width: window.innerWidth <= 1024 ? '100%' : '1322px',
    marginLeft: window.innerWidth <= 1024 ? '0' : '-41px',
    height: '520px',
    overflowY: 'auto',
    padding: window.innerWidth <= 480 ? '10px' : '20px',
    boxSizing: 'border-box'
  };

  const tableContainerStyle = {
    width: window.innerWidth <= 768 ? '100%' : '880px',
    height: '260px',
    borderRadius: '10px',
    padding: window.innerWidth <= 480 ? '10px' : '20px',
    marginBottom: '20px',
    marginLeft: window.innerWidth <= 480 ? '0' : 'auto',
    marginRight: window.innerWidth <= 480 ? '0' : 'auto'
  };

  const filterSelectStyle = {
    marginRight: '10px',
    padding: '5px',
    width: window.innerWidth <= 480 ? '80px' : '120px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    marginBottom: window.innerWidth <= 480 ? '10px' : '0'
  };

  const exportButtonStyle = {
    padding: '8px 15px',
    background: 'rgb(177 93 198)',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: window.innerWidth <= 480 ? '10px' : '-34px',
    float: window.innerWidth <= 480 ? 'none' : 'right'
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
    marginLeft: window.innerWidth <= 480 ? '0' : '-0px',
    fontSize: window.innerWidth <= 480 ? '14px' : '16px'
  };

  const thStyle = {
    padding: window.innerWidth <= 480 ? '5px' : '10px',
    background: 'rgb(177 93 198)',
    textAlign: 'left',
    color: '#fff',
    fontSize: window.innerWidth <= 480 ? '12px' : '14px'
  };

  const tdStyle = {
    padding: window.innerWidth <= 480 ? '5px' : '10px',
    color: '#000',
    fontWeight: 'normal',
    fontSize: window.innerWidth <= 480 ? '12px' : '17px'
  };

  const supportButtonStyle = {
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    padding: window.innerWidth <= 480 ? '5px 10px' : '8px 16px',
    borderRadius: '8px',
    fontSize: window.innerWidth <= 480 ? '12px' : '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  };

  const paginationButtonStyle = {
    marginRight: '10px',
    padding: '8px 16px',
    backgroundColor: '#b15dc6',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s'
  };

  const footerStyle = {
    position: 'fixed',
    bottom: '0px',
    left: '0px',
    height: '30px',
    width: '100%',
    backgroundColor: 'white',
    color: 'black',
    textAlign: 'center',
    padding: '5px',
    fontWeight: 'bold',
    fontSize: window.innerWidth <= 480 ? '10px' : '14px',
    boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
    zIndex: '999'
  };

  return (
    <div style={containerStyle}>
      <div style={tableContainerStyle}>
        <div style={{ marginTop: window.innerWidth <= 480 ? '0' : '-30px' }}>
          <div style={{
            width: window.innerWidth <= 768 ? '100%' : '937px',
            background: '#f9f9f9',
            borderRadius: '10px',
            marginTop: window.innerWidth <= 480 ? '10px' : '-35px',
            padding: window.innerWidth <= 480 ? '10px' : '20px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            marginLeft: window.innerWidth <= 480 ? '0' : '-210px',
          }}>
            <div style={{
              display: window.innerWidth <= 480 ? 'block' : 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                style={filterSelectStyle}
              >
                <option value="">Year</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </select>

              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value.padStart(2, "0"))}
                style={filterSelectStyle}
              >
                <option value="">Month</option>
                <option value="01">January</option>
                <option value="02">February</option>
                <option value="03">March</option>
                <option value="04">April</option>
                <option value="05">May</option>
                <option value="06">June</option>
                <option value="07">July</option>
                <option value="08">August</option>
                <option value="09">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>

              <select
                value={selectedWeek}
                onChange={(e) => setSelectedWeek(e.target.value)}
                style={filterSelectStyle}
              >
                <option value="">Week</option>
                <option value="1">Week 1</option>
                <option value="2">Week 2</option>
                <option value="3">Week 3</option>
                <option value="4">Week 4</option>
                <option value="5">Week 5</option>
              </select>

              <select
                style={{
                  ...filterSelectStyle,
                  marginLeft: window.innerWidth <= 480 ? '0' : '10px'
                }}
              >
                <option value="">Today</option>
                <option value="1">30-03-2025</option>
                <option value="2">29-03-2025</option>
                <option value="3">28-03-2025</option>
              </select>

              <button
                style={exportButtonStyle}
                className='orderpayments-export'
              >
                <FaFileExport style={{ fontSize: window.innerWidth <= 480 ? '16px' : '20px' }} />
                {window.innerWidth > 480 ? 'Export' : ''}
              </button>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>Order Id</th>
                    <th style={thStyle}>Date</th>
                    {window.innerWidth > 480 && <th style={thStyle}>Time</th>}
                    <th style={thStyle} onClick={() => openPopup("name")}>
                      Name <FaFilter style={{ marginLeft: "5px", color: "#fff" }} />
                    </th>
                    {window.innerWidth > 768 && (
                      <th style={thStyle} onClick={() => openPopup("orderType")}>
                        Order Type <FaFilter style={{ marginLeft: "5px", color: "#fff" }} />
                      </th>
                    )}
                    <th style={thStyle} onClick={() => openPopup("paymentMethod")}>
                      Payment <FaFilter style={{ marginLeft: "5px", color: "#fff" }} />
                    </th>
                    <th style={thStyle}>Amount</th>
                    <th style={thStyle}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentOrders.length > 0 ? (
                    currentOrders.map((order, index) => (
                      <tr key={index}>
                        <td style={tdStyle}>{order.orderId}</td>
                        <td style={tdStyle}>{order.orderDateAndTime?.split("T")[0]}</td>
                        {window.innerWidth > 480 && (
                          <td style={tdStyle}>
                            {new Date(order.orderDateAndTime).toLocaleTimeString("en-IN", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </td>
                        )}
                        <td style={tdStyle}>{order.userName}</td>
                        {window.innerWidth > 768 && (
                          <td style={tdStyle}>{order.orderType}</td>
                        )}
                        <td style={tdStyle}>{order.paymentMethod}</td>
                        <td style={tdStyle}>₹{Number(order.grandTotal).toFixed(0)}</td>
                        <td style={{ ...tdStyle, color: "#000", cursor: "pointer" }}>
                          <button
                            style={supportButtonStyle}
                            onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
                            onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
                            onClick={() => {
                              setShowPopup(true);
                              setSelectedOrderId(order.orderId);
                            }}
                          >
                            {window.innerWidth > 480 ? 'Support' : 'Help'}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={window.innerWidth <= 480 ? 5 : window.innerWidth <= 768 ? 7 : 8}
                        style={{ textAlign: "center", padding: "10px" }}>
                        No orders found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  ...paginationButtonStyle,
                  backgroundColor: currentPage === 1 ? "#ccc" : "#b15dc6",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                Prev
              </button>

              <span style={{ margin: "0 15px", fontWeight: "bold", color: "#333" }}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{
                  ...paginationButtonStyle,
                  backgroundColor: currentPage === totalPages ? "#ccc" : "#b15dc6",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                }}
              >
                Next
              </button>
            </div>

            {isPopupOpen && (
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#fff",
                  padding: "20px",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  zIndex: 1000,
                  width: window.innerWidth <= 480 ? "90%" : "300px",
                  textAlign: "center",
                }}
              >
                <button
                  onClick={() => setIsPopupOpen(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#333",
                  }}
                >
                  ✖
                </button>

                <h3>Filter by {currentFilter === "name" ? "Name" : currentFilter === "orderType" ? "Order Type" : "Payment"}</h3>
                <input
                  type="text"
                  placeholder={`Enter ${currentFilter}`}
                  value={filters[currentFilter]}
                  onChange={handleFilterChange}
                  style={{ width: "100%", padding: "8px", margin: "10px 0", borderRadius: "4px" }}
                />
                <button
                  onClick={() => setIsPopupOpen(false)}
                  style={{ padding: "8px 12px", background: "rgb(177 93 198)", color: "#fff", borderRadius: "4px", border: "none" }}
                >
                  Apply
                </button>
              </div>
            )}

            {showPopup && (
              <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}>
                <div style={{
                  backgroundColor: "#fff",
                  padding: "25px",
                  borderRadius: "10px",
                  width: window.innerWidth <= 480 ? "90%" : "400px",
                  boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
                }}>
                  <h3>Raise a Ticket for Order ID: {selectedOrderId}</h3>

                  <label>Ticket Type:</label>
                  <select
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginTop: "5px",
                      marginBottom: "15px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                    }}
                    value={ticketType}
                    onChange={(e) => setTicketType(e.target.value)}
                  >
                    <option value="">Select type</option>
                    <option value="DELIVERY_ISSUE">Delivery Issue</option>
                    <option value="PAYMENT_PROBLEM">Payment Problem</option>
                    <option value="WRONG_ORDER">Wrong Order</option>
                    <option value="SERVICE_QUALITY">Service Quality</option>
                    <option value="OTHER">Other</option>
                  </select>

                  <label>Message:</label>
                  <textarea
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginTop: "5px",
                      marginBottom: "15px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                      height: "80px"
                    }}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Write your message..."
                  />

                  <label>Upload Image:</label>
                  <input
                    type="file"
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginTop: "5px",
                      marginBottom: "15px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                    }}
                    onChange={handleImageUpload}
                    accept="image/*"
                  />

                  <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button onClick={() => setShowPopup(false)} style={{
                      backgroundColor: "#ccc",
                      color: "#000",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                    }}>
                      Cancel
                    </button>
                    <button onClick={handleSend} style={{
                      backgroundColor: "#4CAF50",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                    }}>
                      Send
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={footerStyle}>
        @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
      </div>
    </div>
  );
};

export default Order;